// extracted by mini-css-extract-plugin
export var borderless = "styles-module--borderless--35c8e";
export var content = "styles-module--content--21cb8";
export var desc = "styles-module--desc--0d691";
export var horizontal = "styles-module--horizontal--f480c";
export var outline = "styles-module--outline--34651";
export var title = "styles-module--title--f6c5f";
export var vertical = "styles-module--vertical--2c725";